import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { AgGridTable } from 'components/common';

const formatDate = (date) => (date ? format(new Date(date), 'MMM, dd-yyyy h:mm aa') : '');

const BookingTable = ({ data }) => {
  const columnDefs = useMemo(() => [
    {
      headerName: 'Booking ID#',
      field: 'booking_number',
      minWidth: 120,
      cellRenderer: (p) => <Link to={`/booking/car/${p.data?.id}`} target="_blank">{p.value}</Link>,
    },
    { headerName: 'From date', field: 'from_date', minWidth: 160, valueFormatter: (p) => formatDate(p.value) },
    { headerName: 'To date', field: 'to_date', minWidth: 160, valueFormatter: (p) => formatDate(p.value) },
    { headerName: 'Address pickup location', field: 'pickup_location', minWidth: 200 },
    { headerName: 'Address drop location', field: 'drop_location', minWidth: 200 },
    {
      headerName: 'Drivers',
      field: 'driver_trans',
      minWidth: 200,
      cellRenderer: (p) => (
        <ul className="tw-list-none tw-p-0 tw-m-0">
          {(p.value || []).map((item, i) => (
            <li key={i}>{item.driver?.name} <span className="tw-text-blue-600">({item.car?.name})</span></li>
          ))}
        </ul>
      ),
    },
    { headerName: 'Notes', field: 'notes', minWidth: 180 },
  ], []);

  return (
    <div className="tw-bg-white tw-rounded tw-border tw-border-solid tw-border-slate-200 tw-overflow-hidden">
      <AgGridTable rowData={data || []} columnDefs={columnDefs} pagination height="40vh" />
    </div>
  );
};

BookingTable.propTypes = {
  data: PropTypes.array,
};

export default BookingTable;
